import { EntityType } from "@/services/hooks/entities/useEntityType";

export enum FieldDisplayType {
  TEXT = "text",
  TEXTAREA = "textarea",
  NUMBER = "number",
  PERCENTAGE = "percentage",
  DATE = "date",
  DATE_RANGE = "dateRange",
  SINGLE_SELECT = "singleSelect",
  MULTI_SELECT = "multiSelect",
  EMAIL = "email",
  URL = "url",
  CURRENCY = "currency",
  SWITCH = "switch",
  CHECKBOX = "checkbox",
  CHECKLIST_ITEM = "checkListItem",
  FILE_UPLOAD = "fileUpload",
  USERS = "users",
  COMPANIES = "companies",
  PEOPLE = "people",
  LEADS = "leads",
  DEALS = "deals",
  PARTNERS = "partners",
  PARTNER_CONTACTS = "partnersContacts",
  PRODUCTS = "products",
  LICENSES = "licenses",
  PEOPLE_IN_COMPANY = "peopleInCompany",
  CHECKBOX_WITH_REQUIRED_TEXT = "checkboxWithRequiredText",
  BOOL = "bool",
  BUTTON = "button",
  CURRENCIES = "currencies",
  PHONE = "phone",
  COUNTRIES = "countries"
}

export interface AddFieldProps {
  onBack: () => void;
  onCancel: () => void;
  onSave: (fieldData: any) => void;
  entityType?: EntityType;
}

export interface LinkedFieldData {
  objectType: string;
  fieldId: string;
  fieldLabel: string;
  fieldDisplayType: string;
}

export interface OptionsManagerData {
  options: string[];
  allowUsersToAdd: boolean;
  defaultValue: string;
  checkboxInlineText?: string;
}
